module.exports = __webpack_public_path__ + "static/img/laptop.01cce64.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/remote-resources/img/laptop.png
// module id = 0QV2
// module chunks = 1